import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
import 'wangeditor/release/wangEditor.min.css'
import './styles/index.scss'
import './permission'
import './utils/filters'
import './utils/global-components'

Vue.prototype.$bus = new Vue()

Vue.use(ElementUI)

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
